/* Locale-aware root: '/' on English, '/ar/' on Arabic. */
window.BB_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
/* =========================================================
Mubkhar Bundle Builder — Enhanced with Bukhoor 1 Special Rules
========================================================= */

(function () {
  /**
   * DOM Ready helper
   */
  const ready = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn)
      : fn();

  /**
   * Query selector helpers
   */
  const $1 = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /**
   * Read bundle configuration
   */
  function readCFG() {
    try {
      return JSON.parse($1('#BundleConfig')?.textContent || '{}');
    } catch (e) {
      console.warn('[Bundle] Configuration parse error:', e);
      return {};
    }
  }

  /**
   * Expands a single slot config with max_qty > 1 into multiple individual slots.
   */
  function expandSlotsConfiguration(originalSlots) {
    const expandedSlots = [];
    originalSlots.forEach(slot => {
      const maxQty = Number(slot.max_qty || 1);
      if (maxQty <= 1) {
        expandedSlots.push({ ...slot, max_qty: 1 });
      } else {
        for (let i = 0; i < maxQty; i++) {
          expandedSlots.push({
            ...slot,
            key: `${slot.key}-${i}`,
            label_en: `${slot.label_en} - ${i + 1}`,
            label_ar: `${slot.label_ar} - ${i + 1}`,
            max_qty: 1,
            original_key: slot.key
          });
        }
      }
    });
    return expandedSlots;
  }

  /**
   * ENHANCED: Wait for image to be available with retry logic
   */
  function waitForImage(card, maxAttempts = 10, delay = 100) {
    return new Promise((resolve) => {
      let attempts = 0;

      const checkImage = () => {
        attempts++;
        const img = extractImageUrl(card);

        if (img || attempts >= maxAttempts) {
          resolve(img);
        } else {
          setTimeout(checkImage, delay);
        }
      };

      checkImage();
    });
  }

  /**
   * ENHANCED: Extract image URL from card
   */
  function extractImageUrl(card) {
    const images = $$('img', card);

    for (const img of images) {
      const computed = window.getComputedStyle(img);
      if (computed.display === 'none' || computed.visibility === 'hidden' || computed.opacity === '0') {
        continue;
      }

      let url = img.currentSrc || img.src || img.getAttribute('src');

      if (!url || url.includes('data:image') || url.includes('placeholder')) {
        url = img.getAttribute('data-src') ||
              img.getAttribute('data-srcset')?.split(' ')[0] ||
              img.getAttribute('srcset')?.split(' ')[0];
      }

      if (url && url.trim() && !url.includes('data:image') && !url.includes('placeholder')) {
        url = url.trim();
        if (url.startsWith('//')) {
          url = 'https:' + url;
        }
        if (url.startsWith('http') || url.startsWith('/')) {
          console.log('[Bundle] Found image URL:', url);
          return url;
        }
      }
    }

    const specificSelectors = [
      '.grid__image-ratio img',
      '.grid-product__image img',
      '.image-wrap img',
      '.card__media img',
      'picture source',
      'noscript img'
    ];

    for (const selector of specificSelectors) {
      const el = card.querySelector(selector);
      if (el) {
        let url = '';
        if (el.tagName === 'SOURCE') {
          url = el.getAttribute('srcset')?.split(' ')[0] || '';
        } else {
          url = el.getAttribute('src') || el.getAttribute('data-src') || '';
        }

        if (url && !url.includes('data:image') && !url.includes('placeholder')) {
          url = url.trim();
          if (url.startsWith('//')) url = 'https:' + url;
          if (url.startsWith('http') || url.startsWith('/')) {
            console.log('[Bundle] Found image via selector:', selector, url);
            return url;
          }
        }
      }
    }

    const noscript = card.querySelector('noscript');
    if (noscript) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = noscript.textContent;
      const noscriptImg = tempDiv.querySelector('img');
      if (noscriptImg) {
        let url = noscriptImg.getAttribute('src');
        if (url && !url.includes('placeholder')) {
          if (url.startsWith('//')) url = 'https:' + url;
          console.log('[Bundle] Found image in noscript:', url);
          return url;
        }
      }
    }

    const bgElements = [card, ...$$('[class*="image"]', card), ...$$('[class*="media"]', card)];
    for (const el of bgElements) {
      const bgImage = window.getComputedStyle(el).backgroundImage;
      if (bgImage && bgImage !== 'none') {
        const match = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
        if (match && match[1] && !match[1].includes('placeholder')) {
          let url = match[1];
          if (url.startsWith('//')) url = 'https:' + url;
          console.log('[Bundle] Found background image:', url);
          return url;
        }
      }
    }

    console.warn('[Bundle] No image found for card:', card);
    return '';
  }

  /**
   * Get card data - async version
   */
  async function getCardDataAsync(card) {
    const pid = card.dataset.productId;
    const handle = card.dataset.productHandle;
    const tags = (card.dataset.productTags || '').split(',').map(s => s.trim()).filter(Boolean);
    const form = card.querySelector('form[action*="/cart/add"]') || card.querySelector('.grid-product__form');
    const variantId = form?.querySelector('input[name="id"]')?.value || '';
    const title = card.querySelector('.grid-product__title a, .grid-product__title')?.textContent?.trim() || handle || pid;

    const img = await waitForImage(card);

    // Enhanced price extraction - try multiple selectors
    let formattedPrice = '';
    let price = '0';

    const priceSelectors = [
      '.price__regular .price-item--regular',
      '.price__sale .price-item--sale',
      '[data-price]',
      '.price__regular .price-item',
      '.price-item',
      '.price',
      '.grid-product__price'
    ];

    for (const selector of priceSelectors) {
      const priceEl = card.querySelector(selector);
      if (priceEl) {
        formattedPrice = priceEl.textContent?.trim() || '';
        price = priceEl.dataset?.price || priceEl.textContent?.replace(/[^\d.]/g, '') || '0';

        if (formattedPrice) {
          console.log('[Bundle] 💰 Price extracted:', {
            selector: selector,
            formattedPrice: formattedPrice,
            rawPrice: price,
            product: handle
          });
          break;
        }
      }
    }

    return { pid, handle, tags, variantId, title, img, price, formattedPrice };
  }

  // ============================================================
  // CANONICAL PRICE HELPERS (unified pricing fix — same in every store)
  // ============================================================
  // Locale-agnostic parser. Treats the LAST dot or comma as the decimal
  // separator, strips everything else. Handles "3.640 KD", "QAR 96,00",
  // "$1,234.56", "1.234,56 €", "23900".
  function parseLocalePrice(text) {
    if (!text) return 0;
    const stripped = String(text).replace(/[^\d.,]/g, '');
    if (!stripped) return 0;
    const lastDot = stripped.lastIndexOf('.');
    const lastComma = stripped.lastIndexOf(',');
    const lastSep = Math.max(lastDot, lastComma);
    if (lastSep < 0) return parseFloat(stripped) || 0;
    const intPart = stripped.slice(0, lastSep).replace(/[.,]/g, '');
    const decPart = stripped.slice(lastSep + 1);
    return parseFloat(`${intPart}.${decPart}`) || 0;
  }

  // Detect currency decimals from the server-rendered formatted_price.
  // KWD/QAR/OMR/BHD = 3, AED/SAR/USD = 2. Falls back to 3 if unknown.
  function detectCurrencyDecimals() {
    try {
      const cfg = (typeof window !== 'undefined') && window.__BB_CFG__;
      const fmt = (cfg && cfg.bundle && cfg.bundle.formatted_price) || '';
      const m = fmt.match(/[.,](\d+)(?!\d)/);
      if (m) return m[1].length;
    } catch (e) {}
    return 3;
  }

  // Read a card's price as a string in MAJOR units. data-price (if present)
  // is in subunits → divide by 10^decimals. Otherwise parseLocalePrice
  // the visible text. Single source of truth for price reads in the wizard.
  function readPriceFromCard(card) {
    const priceEl = card.querySelector('[data-price], .price__regular .price-item, .price, .grid-product__price');
    if (!priceEl) return '0';
    const sub = priceEl.dataset && priceEl.dataset.price;
    if (sub && !isNaN(parseFloat(sub))) {
      const decimals = detectCurrencyDecimals();
      return (parseFloat(sub) / Math.pow(10, decimals)).toFixed(decimals);
    }
    const major = parseLocalePrice(priceEl.textContent || '');
    return String(major);
  }

  /**
   * Synchronous version for backward compatibility
   */
  function getCardData(card) {
    const pid = card.dataset.productId;
    const handle = card.dataset.productHandle;
    const tags = (card.dataset.productTags || '').split(',').map(s => s.trim()).filter(Boolean);
    const form = card.querySelector('form[action*="/cart/add"]') || card.querySelector('.grid-product__form');
    const variantId = form?.querySelector('input[name="id"]')?.value || '';
    const title = card.querySelector('.grid-product__title a, .grid-product__title')?.textContent?.trim() || handle || pid;

    const img = extractImageUrl(card);

    // Enhanced price extraction
    let formattedPrice = '';
    let price = '0';

    const priceSelectors = [
      '.price__regular .price-item--regular',
      '.price__sale .price-item--sale',
      '[data-price]',
      '.price__regular .price-item',
      '.price-item',
      '.price',
      '.grid-product__price'
    ];

    for (const selector of priceSelectors) {
      const priceEl = card.querySelector(selector);
      if (priceEl) {
        formattedPrice = priceEl.textContent?.trim() || '';
        price = priceEl.dataset?.price || priceEl.textContent?.replace(/[^\d.]/g, '') || '0';

        if (formattedPrice) {
          break;
        }
      }
    }

    // Override raw price with the locale/decimal-aware reader.
    // (The loop above still extracts formattedPrice for display use.)
    price = readPriceFromCard(card);
    return { pid, handle, tags, variantId, title, img, price, formattedPrice };
  }

  // Main execution
  ready(function () {
    const header = $1('[data-bundle-header]');
    if (!header) return;

    const CFG = readCFG();
    if (!CFG.bundle || !Array.isArray(CFG.slots)) {
      console.warn('[Bundle] Invalid configuration.');
      return;
    }

    CFG.slots = expandSlotsConfiguration(CFG.slots);
    const isAR = (CFG.locale || '').toLowerCase().startsWith('ar');

    // ===== BUKHOOR 1 DETECTION =====
    const bundleHandle = (CFG.bundle.handle || '').toLowerCase();
    const isBukhoor1 = bundleHandle.includes('bukhour-1') || bundleHandle.includes('bukhoor-1');

    console.log('[Bundle] Handle:', CFG.bundle.handle);
    console.log('[Bundle] Bukhoor 1 mode:', isBukhoor1);

    // --- STATE MANAGEMENT ---
    const SS_KEY = `bb:${CFG.bundle.id}`;
    // Addons + Message are optional features. CFG.addons is an array
    // (possibly empty); CFG.message_enabled is a boolean. The wizard
    // skips the corresponding phase when these are empty/false.
    const ADDONS = Array.isArray(CFG.addons) ? CFG.addons : [];
    const MESSAGE_ENABLED = !!CFG.message_enabled;

    const emptyState = {
      slots: {},
      // addons[categoryKey] = [] | [{productId, variantId, title, img, price, formattedPrice}]
      addons: {},
      // greeting message — empty strings if user skips or didn't fill
      message: { from: '', to: '', message: '' },
      // phase tracks where the customer is in the wizard
      phase: 'slots', // 'slots' | 'addons' | 'message' | 'done'
    };
    CFG.slots.forEach(s => { emptyState.slots[s.key] = []; });
    ADDONS.forEach(c => { emptyState.addons[c.key] = []; });
    let STATE = loadState();

    function loadState() {
      try {
        const raw = sessionStorage.getItem(SS_KEY);
        if (!raw) return JSON.parse(JSON.stringify(emptyState));
        const parsed = JSON.parse(raw);
        const clean = JSON.parse(JSON.stringify(emptyState));
        // Slots
        CFG.slots.forEach(s => {
          if (parsed.slots?.[s.key] && Array.isArray(parsed.slots[s.key])) {
            clean.slots[s.key] = parsed.slots[s.key];
          }
        });
        // Addons (filter to only currently-configured categories — if a
        // category was removed since the user's last visit, drop it)
        ADDONS.forEach(c => {
          if (parsed.addons?.[c.key] && Array.isArray(parsed.addons[c.key])) {
            clean.addons[c.key] = parsed.addons[c.key];
          }
        });
        // Message
        if (parsed.message && typeof parsed.message === 'object') {
          clean.message.from = String(parsed.message.from || '');
          clean.message.to = String(parsed.message.to || '');
          clean.message.message = String(parsed.message.message || '');
        }
        // Phase — only restore if it's still a valid phase given current
        // CFG. If user was on 'addons' but addons were removed since,
        // recompute via getNextPhase.
        if (typeof parsed.phase === 'string') {
          clean.phase = parsed.phase;
        }
        return clean;
      } catch {
        return JSON.parse(JSON.stringify(emptyState));
      }
    }

    function saveState() {
      sessionStorage.setItem(SS_KEY, JSON.stringify(STATE));
    }

    // ============================================================
    // PHASE MODEL (Slots → Add-ons → Message → Done)
    //
    // Add-ons and Message are optional per-bundle. allSlotsFilled()
    // gates the transition out of 'slots'; from there we walk:
    //   addons (if ADDONS.length > 0)  →  message (if MESSAGE_ENABLED)  →  done
    // The customer can also Skip past addons/message at any point.
    // ============================================================
    function allSlotsFilled() {
      return CFG.slots.every(
        (s) => !Number(s.required || 1) || (STATE.slots[s.key]?.length || 0) >= 1
      );
    }

    function getNextPhase(current) {
      const order = ['slots', 'addons', 'message', 'done'];
      const idx = order.indexOf(current);
      for (let i = idx + 1; i < order.length; i++) {
        const p = order[i];
        if (p === 'addons' && ADDONS.length === 0) continue;
        if (p === 'message' && !MESSAGE_ENABLED) continue;
        return p;
      }
      return 'done';
    }

    function setPhase(p) {
      STATE.phase = p;
      saveState();
      renderPhaseUI();
    }

    // Recompute the correct phase based on what the user has filled so far.
    // Useful on init: if user previously filled all slots, they should land
    // on the next applicable phase, not back on 'slots'.
    function recomputePhase() {
      if (!allSlotsFilled()) {
        STATE.phase = 'slots';
        return;
      }
      // Slots are done. Are we already past slots? Keep the saved phase.
      const valid = ['slots', 'addons', 'message', 'done'];
      if (!valid.includes(STATE.phase)) STATE.phase = getNextPhase('slots');
      // If user is on 'slots' but slots are filled, advance to next.
      if (STATE.phase === 'slots') STATE.phase = getNextPhase('slots');
    }

    // ============================================================
    // ADD-ONS UI
    // Renders a tab strip (one tab per addon category) above the
    // product grid. Picking a product filters via the active tab's
    // filter_tag — same mechanism as slots.
    // ============================================================
    function getActiveAddonCategory() {
      // Default to first addon category whose state is empty;
      // fall back to first category overall.
      const firstEmpty = ADDONS.find(c => (STATE.addons[c.key]?.length || 0) === 0);
      return firstEmpty || ADDONS[0] || null;
    }

    function getActiveAddonFilterTag() {
      const cat = getActiveAddonCategory();
      return cat ? cat.filter_tag : null;
    }

    function renderAddonTabs(activeKey) {
      const container = $1('#bundle-step-filters');
      if (!container) return;
      container.innerHTML = '';

      ADDONS.forEach(cat => {
        const label = isAR ? cat.label_ar : cat.label_en;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'category-link';
        btn.textContent = label;
        btn.dataset.filterTag = cat.filter_tag;
        btn.dataset.addonKey = cat.key;
        if (cat.key === activeKey) btn.classList.add('active');
        // Mark the tab as filled if the user already picked something
        const picked = (STATE.addons[cat.key] || [])[0];
        if (picked) btn.classList.add('is-filled');
        container.appendChild(btn);
      });

      // Skip Add-ons button — advances past all addon tabs.
      const skip = document.createElement('button');
      skip.type = 'button';
      skip.className = 'category-link bb-skip-link';
      skip.textContent = isAR ? 'تخطّي' : 'Skip';
      skip.dataset.action = 'skip-addons';
      container.appendChild(skip);
    }

    function selectAddonTab(filterTag) {
      const cat = ADDONS.find(c => c.filter_tag === filterTag);
      if (!cat) return;
      renderAddonTabs(cat.key);
      applyStepFiltering(filterTag);
      syncGridButtons();
    }

    // Move to next addon category that's still unfilled, or advance
    // out of the addons phase if all are filled or only this one exists.
    function advanceAddonOrPhase() {
      const next = ADDONS.find(c => (STATE.addons[c.key]?.length || 0) === 0);
      if (next) {
        renderAddonTabs(next.key);
        applyStepFiltering(next.filter_tag);
        syncGridButtons();
      } else {
        setPhase(getNextPhase('addons'));
      }
    }

    // ============================================================
    // MESSAGE UI
    // Replaces the product grid with a centered card containing
    // From / To / Message inputs. Save & Skip buttons advance.
    // ============================================================
    function ensureMessageOverlay() {
      let overlay = $1('#bb-message-overlay');
      if (overlay) return overlay;
      overlay = document.createElement('div');
      overlay.id = 'bb-message-overlay';
      overlay.style.cssText = [
        'display:none',
        'max-width:560px',
        'margin:32px auto',
        'padding:28px',
        'border:1px solid #e6e6e6',
        'border-radius:12px',
        'background:#fff',
        'box-shadow:0 4px 16px rgba(0,0,0,0.06)',
      ].join(';');

      overlay.innerHTML = `
        <h2 style="margin:0 0 4px 0;font-size:20px;">${isAR ? 'إضافة رسالة' : 'Add a Greeting Message'}</h2>
        <p style="margin:0 0 20px 0;color:#666;font-size:14px;">
          ${isAR
            ? 'هذه الخطوة اختيارية — يمكنك تخطّيها.'
            : 'Optional — you can skip this step.'}
        </p>
        <label style="display:block;margin-bottom:12px;font-size:13px;color:#333;">
          ${isAR ? 'من' : 'From'}
          <input type="text" data-bb-msg="from" style="display:block;width:100%;padding:10px 12px;margin-top:4px;border:1px solid #ddd;border-radius:6px;font-size:14px;" />
        </label>
        <label style="display:block;margin-bottom:12px;font-size:13px;color:#333;">
          ${isAR ? 'إلى' : 'To'}
          <input type="text" data-bb-msg="to" style="display:block;width:100%;padding:10px 12px;margin-top:4px;border:1px solid #ddd;border-radius:6px;font-size:14px;" />
        </label>
        <label style="display:block;margin-bottom:20px;font-size:13px;color:#333;">
          ${isAR ? 'الرسالة' : 'Message'}
          <textarea data-bb-msg="message" rows="4" style="display:block;width:100%;padding:10px 12px;margin-top:4px;border:1px solid #ddd;border-radius:6px;font-size:14px;resize:vertical;"></textarea>
        </label>
        <div style="display:flex;gap:12px;justify-content:flex-end;">
          <button type="button" data-action="skip-message" style="padding:10px 20px;border:1px solid #ddd;background:#fff;border-radius:8px;cursor:pointer;font-size:14px;">
            ${isAR ? 'تخطّي' : 'Skip'}
          </button>
          <button type="button" data-action="save-message" style="padding:10px 20px;border:none;background:#CB4B17;color:#fff;border-radius:8px;cursor:pointer;font-size:14px;">
            ${isAR ? 'حفظ ومتابعة' : 'Save & Continue'}
          </button>
        </div>
      `;

      // Insert after the bundle header so it sits above the product grid.
      const headerEl = $1('[data-bundle-header]');
      if (headerEl?.parentNode) {
        headerEl.parentNode.insertBefore(overlay, headerEl.nextSibling);
      } else {
        document.body.appendChild(overlay);
      }

      // Wire inputs
      overlay.querySelectorAll('[data-bb-msg]').forEach(input => {
        input.addEventListener('input', () => {
          const key = input.dataset.bbMsg;
          STATE.message[key] = input.value;
          saveState();
        });
      });
      overlay.querySelector('[data-action="save-message"]').addEventListener('click', () => {
        // Pull live values defensively (input handlers may not have flushed)
        overlay.querySelectorAll('[data-bb-msg]').forEach(input => {
          STATE.message[input.dataset.bbMsg] = input.value;
        });
        saveState();
        setPhase(getNextPhase('message'));
      });
      overlay.querySelector('[data-action="skip-message"]').addEventListener('click', () => {
        STATE.message = { from: '', to: '', message: '' };
        saveState();
        setPhase(getNextPhase('message'));
      });

      return overlay;
    }

    function showMessageOverlay() {
      const overlay = ensureMessageOverlay();
      // Restore any saved field values
      overlay.querySelectorAll('[data-bb-msg]').forEach(input => {
        const key = input.dataset.bbMsg;
        input.value = STATE.message[key] || '';
      });
      overlay.style.display = 'block';
      // Hide the product grid while message form is up
      $$('.grid-product').forEach(p => p.style.setProperty('display', 'none', 'important'));
      const filterStrip = $1('#bundle-step-filters');
      if (filterStrip) filterStrip.style.display = 'none';
    }

    function hideMessageOverlay() {
      const overlay = $1('#bb-message-overlay');
      if (overlay) overlay.style.display = 'none';
      const filterStrip = $1('#bundle-step-filters');
      if (filterStrip) filterStrip.style.display = '';
    }

    // ============================================================
    // PHASE-AWARE PRICE & UI ROUTING
    // ============================================================
    function computeBundleTotal() {
      // BUKHOOR 1 CARVE-OUT: bukhoor uses its own bespoke price logic
      // (updateBundlePrice, _custom_price). Don't compete with it.
      if (isBukhoor1) return 0;

      // FIXED-PARENT BUNDLE MODEL (every non-bukhoor bundle):
      //   total = parent variant price + sum(addon prices)
      // Slot picks are "included" in the bundle's fixed price; only
      // add-ons add on top.
      //
      // We derive parentMajor from CFG.bundle.formatted_price (already
      // server-rendered by the Liquid `money` filter), NOT from
      // CFG.bundle.price. Different Shopify stores serialize the integer
      // price differently — some use 2-decimal cents universally, some
      // use 3-decimal subunits for KWD/OMR/BHD — so dividing by a
      // computed factor is unreliable. The formatted string is the
      // single source of truth for the parent's major value.
      const parentMajor = parseLocalePrice(CFG.bundle.formatted_price || CFG.bundle.price || '0');
      const addonsTotal = Object.values(STATE.addons)
        .flat()
        .reduce((acc, it) => acc + (parseFloat(it.price) || 0), 0);
      return parentMajor + addonsTotal;
    }

    function updatePriceDisplay() {
      // Skip if Bukhoor 1 — that flow has its own bespoke price logic.
      if (isBukhoor1) return;

      // Before any picks, prefer the server-rendered formatted_price —
      // it went through the Liquid `money` filter and is already correct
      // for whatever currency/locale the shop runs.
      const slotItems = Object.values(STATE.slots).flat();
      const addonItems = Object.values(STATE.addons || {}).flat();
      if (slotItems.length === 0 && addonItems.length === 0 && CFG.bundle && CFG.bundle.formatted_price) {
        // Server-rendered HTML (e.g. "<span class=money>KD 20.000</span>") —
        // must be set as innerHTML, not textContent, otherwise the markup
        // renders as literal text.
        $$('.bbh__price, .bb-price-value').forEach(el => {
          el.innerHTML = CFG.bundle.formatted_price;
        });
        return;
      }

      const total = computeBundleTotal();
      // Derive output decimals + currency code from formatted_price so
      // we render in the shop's actual currency (KWD vs OMR vs SAR…).
      const fmt = (CFG.bundle && CFG.bundle.formatted_price) || '';
      const decMatch = fmt.match(/[.,](\d+)(?!\d)/);
      const decimals = decMatch ? decMatch[1].length : 3;
      const codeMatch = fmt.match(/[A-Z]{2,3}/);
      const currency = codeMatch ? codeMatch[0] : 'KD';
      // Wrap in <span class="money"> to mirror the server's Shopify
      // money_format markup, so styling stays consistent with the
      // initial server render.
      const formatted = `<span class="money">${total.toFixed(decimals)} ${currency}</span>`;
      $$('.bbh__price, .bb-price-value').forEach(el => {
        el.innerHTML = formatted;
      });
    }

    function renderPhaseUI() {
      switch (STATE.phase) {
        case 'slots':
          hideMessageOverlay();
          renderStepFilters();
          applyStepFiltering();
          syncGridButtons();
          updatePriceDisplay();
          break;
        case 'addons':
          hideMessageOverlay();
          renderAddonTabs(getActiveAddonCategory()?.key);
          applyStepFiltering(getActiveAddonFilterTag());
          syncGridButtons();
          updatePriceDisplay();
          break;
        case 'message':
          showMessageOverlay();
          updatePriceDisplay();
          break;
        case 'done':
          hideMessageOverlay();
          // After done, we want product grid visible again so the customer
          // can review their picks if they scroll back, but no filtering
          // (or filter to nothing — pick whichever feels right).
          $$('.grid-product').forEach(p => p.style.removeProperty('display'));
          updatePriceDisplay();
          break;
      }
      // Refresh the sticky checkout state for the new phase.
      if (typeof syncSticky === 'function') syncSticky();
    }

    // Tab/skip click handler — works for both slot phase and addon phase.
    function handleStepFilterClick(e) {
      const skipBtn = e.target.closest('[data-action="skip-addons"]');
      if (skipBtn) {
        setPhase(getNextPhase('addons'));
        return;
      }
      const target = e.target.closest('[data-filter-tag]');
      if (!target) return;
      if (STATE.phase === 'addons') {
        selectAddonTab(target.dataset.filterTag);
      } else {
        applyStepFiltering(target.dataset.filterTag);
      }
    }

    // ===== BUKHOOR 1: AUTO-FILL SLOT 2 AFTER SLOT 1 =====
    function autoFillSlot2() {
      if (!isBukhoor1 || !CFG.bundle.slot2_default) return;

      const slot2Key = CFG.slots[1]?.key;
      if (!slot2Key) {
        console.warn('[Bukhoor 1] No slot 2 found');
        return;
      }

      // Only fill if slot 2 is empty
      if (!STATE.slots[slot2Key] || STATE.slots[slot2Key].length === 0) {
        const defaultProduct = CFG.bundle.slot2_default;
        STATE.slots[slot2Key] = [{
          productId: String(defaultProduct.productId),
          variantId: String(defaultProduct.variantId),
          title: defaultProduct.title,
          img: defaultProduct.img,
          handle: defaultProduct.handle,
          tags: [],
          price: '15.000', // Original price for discount display
          formattedPrice: 'Free', // Display as free
          originalPrice: '15.000' // Keep track of original value
        }];
        saveState();
        console.log('[Bukhoor 1] ✅ Auto-filled slot 2 with FREE', defaultProduct.title);
      }
    }

    // ===== BUKHOOR 1: UPDATE BUNDLE PRICE WITH DISCOUNT DISPLAY =====
    function updateBundlePrice() {
      if (!isBukhoor1) return;

      const slot1Key = CFG.slots[0]?.key;
      const slot2Key = CFG.slots[1]?.key;
      const slot1Item = STATE.slots[slot1Key]?.[0];
      const slot2Item = STATE.slots[slot2Key]?.[0];

      console.log('[Bukhoor 1] 🔍 Price Update Check:');
      console.log('  Slot 1 Item:', slot1Item);
      console.log('  Slot 2 Item:', slot2Item);

      if (slot1Item) {
        const displayPrice = slot1Item.formattedPrice;
        const priceElements = [
          ...$$('.bbh__price'),
          ...$$('.bb-price-value')
        ];

        console.log('  Found', priceElements.length, 'price elements to update');

        priceElements.forEach(el => {
          // Show discount if both slots filled
          if (slot2Item && slot2Item.originalPrice) {
            const slot1Price = parseFloat(slot1Item.price) || 0;
            const slot2Price = parseFloat(slot2Item.originalPrice) || 15;
            const originalTotal = slot1Price + slot2Price;
            const originalFormatted = `${originalTotal.toFixed(3)} KD`;

            // Create discount display HTML
            el.innerHTML = `
              <span style="text-decoration: line-through; opacity: 0.6; font-size: 0.9em; margin-right: 8px;">${originalFormatted}</span>
              <span style="color: #d32f2f; font-weight: bold;">${displayPrice}</span>
              <span style="display: block; font-size: 0.85em; color: #388e3c; margin-top: 4px;">
                ${isAR ? `وفّر ${slot2Price.toFixed(3)} د.ك` : `Save ${slot2Price.toFixed(3)} KD`}
              </span>
            `;
            console.log('  ✅ Updated with discount:', el.className);
          } else {
            // No discount yet, just show price
            el.textContent = displayPrice;
            console.log('  ✅ Updated:', el.className, '→', displayPrice);
          }
        });

        console.log('[Bukhoor 1] ✅ Price updated to:', displayPrice);
      } else {
        console.log('[Bukhoor 1] ⏳ Slot 1 is empty');
      }
    }

    // --- FILTERING & SLOT LOGIC ---
    function getFirstUnfilledSlot() {
      return CFG.slots.find((slot, index) => {
        // DON'T skip slot 2 for Bukhoor 1 - it's now a regular required slot
        return (STATE.slots[slot.key]?.length || 0) < 1;
      });
    }

    /**
     * Count how many times a product is in the bundle across all slots
     */
    function countProductInBundle(productId) {
      let count = 0;
      Object.values(STATE.slots).forEach(slotItems => {
        if (Array.isArray(slotItems)) {
          slotItems.forEach(item => {
            if (item.productId === productId) count++;
          });
        }
      });
      return count;
    }

    /**
     * Find next available slot for a product based on its tags
     * Returns the next empty expanded slot that matches the product's tag
     */
    function findNextAvailableSlotKeyForTags(tags) {
      if (!Array.isArray(tags)) return null;

      // A product may be tagged for multiple slots (when the bundle has
      // several slots sourced from the same product/collection). Walk slots
      // in order and return the first empty slot whose filter_tag the
      // product carries.
      const nextSlot = CFG.slots.find(slot => {
        return tags.includes(slot.filter_tag) && (STATE.slots[slot.key]?.length || 0) === 0;
      });

      return nextSlot ? nextSlot.key : null;
    }

    /**
     * Check if a product can still be added (has empty slots available)
     */
    function canAddMoreOfProduct(productId, tags) {
      if (!Array.isArray(tags)) return false;

      // Product is addable if ANY empty slot matches ANY of its filter tags.
      return CFG.slots.some(slot => {
        return tags.includes(slot.filter_tag) && (STATE.slots[slot.key]?.length || 0) === 0;
      });
    }

    function applyStepFiltering(activeTag = null) {
      let currentFilterTag = activeTag;
      if (!currentFilterTag) {
        const firstUnfilledSlot = getFirstUnfilledSlot();
        currentFilterTag = firstUnfilledSlot ? firstUnfilledSlot.filter_tag : null;
      }

      console.log('[Bundle] ===== FILTERING START =====');
      console.log('[Bundle] Active filter tag:', currentFilterTag);

      // Get ALL product cards directly (they're NOT inside .grid__item)
      const allProducts = $$('.grid-product');
      console.log('[Bundle] Total products found:', allProducts.length);

      if (!currentFilterTag) {
        console.log('[Bundle] No filter tag - hiding all products');
        allProducts.forEach(product => {
          product.style.setProperty('display', 'none', 'important');
        });
        syncActiveFilter(null);
        return;
      }

      let visibleCount = 0;
      let hiddenCount = 0;

      // Process each product directly
      allProducts.forEach((product, index) => {
        const productHandle = product.dataset.productHandle || 'unknown';
        const productTagsString = product.dataset.productTags || '';
        const productTags = productTagsString.split(',').map(tag => tag.trim()).filter(t => t);
        const shouldShow = productTags.includes(currentFilterTag);

        console.log(`[Bundle] Product ${index} (${productHandle}):`, {
          tags: productTags.slice(0, 3), // Show first 3 tags only
          filterTag: currentFilterTag,
          shouldShow: shouldShow
        });

        if (shouldShow) {
          product.style.removeProperty('display');
          product.classList.add('bb-filtered-in');
          product.classList.remove('bb-filtered-out');
          visibleCount++;
        } else {
          product.style.setProperty('display', 'none', 'important');
          product.classList.add('bb-filtered-out');
          product.classList.remove('bb-filtered-in');
          hiddenCount++;
        }
      });

      console.log('[Bundle] Filter complete - Visible:', visibleCount, 'Hidden:', hiddenCount);
      console.log('[Bundle] ===== FILTERING END =====');
      syncActiveFilter(currentFilterTag);
    }

    function renderStepFilters() {
      const container = $1('#bundle-step-filters');
      if (!container) return;

      container.style.display = '';
      container.innerHTML = '';
      const uniqueFilters = [...new Map(CFG.slots.map(item => [item.filter_tag, item])).values()];

      uniqueFilters.forEach(slot => {
        const label = isAR ? (slot.label_ar.split(' - ')[0] || slot.label_en.split(' - ')[0]) : (slot.label_en.split(' - ')[0] || slot.key);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'category-link';
        button.textContent = label;
        button.dataset.filterTag = slot.filter_tag;
        container.appendChild(button);
      });

      // Bind the unified handler ONCE — it routes by phase (slots vs addons).
      if (!container.dataset.bbBound) {
        container.addEventListener('click', handleStepFilterClick);
        container.dataset.bbBound = 'true';
      }
    }

    function syncActiveFilter(activeTag) {
      $$('#bundle-step-filters .category-link').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.filterTag === activeTag);
      });
    }

    // --- UI RENDERING ---
    function renderSlots() {
      const slotsContainer = $1('.bb-slots', header);
      if (!slotsContainer) return;
      slotsContainer.innerHTML = '';

      CFG.slots.forEach((slot, index) => {
        const el = document.createElement('div');
        el.dataset.slot = true;
        el.dataset.slotKey = slot.key;
        el.dataset.slotLabel = isAR ? slot.label_ar : slot.label_en;

        const sel = (STATE.slots[slot.key] || [])[0];

        if (sel) {
          el.className = 'bb-slot is-filled';
          el.innerHTML = `
            <div class="bb-slot__filled">
              <button type="button" class="bb-slot__remove" data-remove-slot="${slot.key}" data-product-id="${sel.productId}">×</button>
              <div class="bb-slot__thumb">${sel.img ? `<img src="${sel.img}" alt="${sel.title || ''}" loading="eager">` : ''}</div>
            </div>`;
        } else {
          el.className = 'bb-slot is-empty';
          el.innerHTML = `<div class="bb-slot__inner"><div class="bb-slot__placeholder" aria-hidden="true">+</div></div>`;
        }
        slotsContainer.appendChild(el);
      });

      const nextSlot = getFirstUnfilledSlot();
      $$('.bb-slots [data-slot]', header).forEach(el => {
        el.classList.remove('is-next');
        if (nextSlot && el.dataset.slotKey === nextSlot.key) {
          el.classList.add('is-next');
        }
      });

      const allRequiredFilled = CFG.slots.every((s, idx) => {
        // Skip slot 2 requirement for Bukhoor 1 (auto-filled)
        if (isBukhoor1 && idx === 1) return true;
        return !Number(s.required || 1) || (STATE.slots[s.key]?.length || 0) >= 1;
      });

      $$('[data-bundle-checkout]').forEach(cta => {
        cta.disabled = !allRequiredFilled;
        cta.setAttribute('aria-disabled', String(!allRequiredFilled));
      });

      // Update price for Bukhoor 1
      if (isBukhoor1) {
        updateBundlePrice();
      }

      syncSticky();
    }

    function setButtonState(card, productId, locked = false, ineligible = false) {
      const btn = card.querySelector('[data-bb-role="add"], .grid-product__cart-btn.add-to-cart, [type="submit"][name="add"]');
      if (!btn) return;

      card.classList.remove('bb-ineligible', 'bb-locked', 'bb-has-items');

      // Remove existing count badge if any
      const existingBadge = card.querySelector('.bb-product-count');
      if (existingBadge) existingBadge.remove();

      let text, isDisabled = false;

      if (ineligible) {
        card.classList.add('bb-ineligible');
        text = isAR ? 'غير متاح' : 'Not eligible';
        isDisabled = true;
      } else if (locked) {
        card.classList.add('bb-locked');
        text = isAR ? 'مُؤمَّن' : 'Locked';
        isDisabled = true;
      } else {
        const data = getCardData(card);
        const currentCount = countProductInBundle(productId);
        const canAddMore = canAddMoreOfProduct(productId, data.tags);

        if (currentCount > 0) {
          card.classList.add('bb-has-items');

          // Create and add count badge
          const countBadge = document.createElement('span');
          countBadge.className = 'bb-product-count';
          countBadge.textContent = currentCount;

          if (canAddMore) {
            text = isAR ? 'أضف عنصر إضافي' : 'Add Extra Item';
            isDisabled = false;
            // Insert badge before button
            btn.parentElement.insertBefore(countBadge, btn);
          } else {
            text = isAR ? 'تمت الإضافة' : 'Added';
            isDisabled = true;
            // Still show count even when maxed out
            btn.parentElement.insertBefore(countBadge, btn);
          }
        } else {
          text = isAR ? 'أضف إلى الحزمة' : 'Add to Bundle';
          isDisabled = false;
        }
      }

      btn.textContent = text;
      btn.disabled = isDisabled;
      btn.setAttribute('aria-disabled', String(isDisabled));
    }

    function syncGridButtons() {
      // In addons phase, the "active filter" is the active addon category's
      // filter_tag; eligibility is across slots OR addons.
      const inAddons = STATE.phase === 'addons';
      const activeSlot = inAddons ? null : getFirstUnfilledSlot();
      const activeAddonTag = inAddons ? getActiveAddonFilterTag() : null;
      const eligibilityTags = [
        ...CFG.slots.map(s => s.filter_tag),
        ...ADDONS.map(c => c.filter_tag),
      ];

      $$('.grid-product').forEach(card => {
        const data = getCardData(card);

        // Ineligible: product doesn't belong to ANY slot or addon category.
        const isEligibleForBundle = eligibilityTags.some(t => data.tags.includes(t));
        if (!isEligibleForBundle) {
          setButtonState(card, data.pid, false, true);
          return;
        }

        // In addons phase: lock products that don't carry the active
        // category's filter tag.
        if (inAddons) {
          if (activeAddonTag && !data.tags.includes(activeAddonTag)) {
            setButtonState(card, data.pid, true, false);
            return;
          }
          setButtonState(card, data.pid, false, false);
          return;
        }

        // Slots phase: lock products that aren't valid for the active slot.
        // Supports multi-tag products (same product valid in multiple slots).
        if (activeSlot && !data.tags.includes(activeSlot.filter_tag)) {
          setButtonState(card, data.pid, true, false);
          return;
        }

        setButtonState(card, data.pid, false, false);
      });
    }

    // --- EVENT HANDLERS ---
    function handleRemoveClick(key, productId) {
      // Allow removing slot 2 in Bukhoor 1 mode (user can change selection)

      if (!key || !productId || !STATE.slots[key]) return;
      STATE.slots[key] = [];
      saveState();
      // Removing a slot pick takes us back to the slots phase.
      // (Customer needs to refill before they can advance again.)
      if (STATE.phase !== 'slots') {
        STATE.phase = 'slots';
        saveState();
      }
      renderSlots();
      renderPhaseUI();
    }

    async function handleAddClick(e) {
      const btn = e.target.closest('[data-bb-role="add"], .grid-product__cart-btn.add-to-cart, [type="submit"][name="add"]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();

      const card = btn.closest('.grid-product');
      if (!card) return;

      // Use async version to ensure we get the image and formatted price
      const data = await getCardDataAsync(card);

      // ── Add-ons phase: write into STATE.addons keyed by category, not slots.
      // Customer picks at most 1 product per addon category; replace any
      // existing pick on re-click. Then advance to next addon or out of phase.
      if (STATE.phase === 'addons') {
        const cat = ADDONS.find(c => data.tags.includes(c.filter_tag));
        if (!cat) {
          card.classList.add('bb-shake');
          setTimeout(() => card.classList.remove('bb-shake'), 500);
          return;
        }
        STATE.addons[cat.key] = [{
          productId: data.pid,
          variantId: data.variantId,
          title: data.title,
          img: data.img,
          handle: data.handle,
          tags: data.tags,
          price: data.price,
          formattedPrice: data.formattedPrice,
          categoryKey: cat.key,
        }];
        saveState();
        updatePriceDisplay();
        advanceAddonOrPhase();
        return;
      }

      // ── Slots phase (default): existing behavior.
      const key = findNextAvailableSlotKeyForTags(data.tags);

      if (!key) {
        card.classList.add('bb-shake');
        setTimeout(() => card.classList.remove('bb-shake'), 500);
        return;
      }

      STATE.slots[key] = [{
        productId: data.pid,
        variantId: data.variantId,
        title: data.title,
        img: data.img,
        handle: data.handle,
        tags: data.tags,
        price: data.price,
        formattedPrice: data.formattedPrice
      }];

      const currentCount = countProductInBundle(data.pid);
      console.log('[Bundle] Added to slot:', key, data, 'Total count:', currentCount);
      saveState();

      // ===== BUKHOOR 1: AUTO-FILL SLOT 2 WHEN SLOT 1 IS FILLED =====
      if (isBukhoor1 && key === CFG.slots[0]?.key) {
        console.log('[Bukhoor 1] 🎯 Slot 1 filled! Auto-filling slot 2 and updating price...');

        // Auto-fill slot 2 with the free bukhoor box
        autoFillSlot2();

        // Update price display with discount info
        setTimeout(() => {
          updateBundlePrice();
          renderSlots();
          syncGridButtons();
          applyStepFiltering();
        }, 150);

        return; // Skip the render below since we're doing it in setTimeout
      }

      renderSlots();
      syncGridButtons();
      applyStepFiltering();
      updatePriceDisplay();

      // If this slot pick filled the last required slot, advance phase
      // automatically (to addons / message / done as configured).
      if (allSlotsFilled() && STATE.phase === 'slots') {
        setPhase(getNextPhase('slots'));
      }
    }

    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-remove-slot]');
      const stickyRemoveBtn = e.target.closest('[data-sticky-remove]');

      if (removeBtn) {
        handleRemoveClick(removeBtn.dataset.removeSlot, removeBtn.dataset.productId);
      } else if (stickyRemoveBtn) {
        const slotKey = stickyRemoveBtn.dataset.stickyRemove;
        const slotData = STATE.slots[slotKey];
        if (slotData && slotData[0]) {
          handleRemoveClick(slotKey, slotData[0].productId);
        }
      } else if (e.target.closest('[data-bb-role="add"], .grid-product__cart-btn.add-to-cart, [type="submit"][name="add"]')) {
        handleAddClick(e);
      }
    }, true);

    // --- STICKY HEADER ---
    const sticky = document.createElement('div');
    sticky.className = 'bb-sticky';
    document.body.appendChild(sticky);

    function buildStickyUI() {
      const slotsHtml = CFG.slots.map((s, index) => {
        const label = isAR ? s.label_ar : s.label_en;

        return `<div class="bb-step" data-slot-key="${s.key}">
                  <span class="bb-dot"></span>
                  <div class="bb-label">${label}</div>
                  <button type="button" class="bb-remove" data-sticky-remove="${s.key}" aria-label="Remove">
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.28949 1.46866H3.67318C3.67318 0.983583 3.60482 0.584919 3.92606 0.257636C4.08207 0.0986906 4.29765 0 4.53507 0H7.46493C7.93977 0 8.32682 0.394329 8.32682 0.878101V1.46866H11.6294C12.1235 1.46866 12.1235 2.23333 11.6294 2.23333H11.0858V10.9723C11.0858 12.0884 10.191 13 9.09552 13H2.90448C1.80901 13 0.914218 12.0884 0.914218 10.9723V2.23333H0.370595C-0.123532 2.23333 -0.123532 1.46866 0.370595 1.46866H1.28949ZM7.19489 4.1755V9.76141C7.19489 10.2648 7.94544 10.2648 7.94544 9.76141V4.1755C7.94544 3.67222 7.19489 3.67222 7.19489 4.1755ZM4.05456 4.1755V9.76141C4.05456 10.2648 4.80511 10.2648 4.80511 9.76141V4.1755C4.80511 3.67222 4.05456 3.67222 4.05456 4.1755ZM4.42373 1.46866H7.57613C7.57613 1.16579 7.64066 0.764672 7.46479 0.764672H4.53507C4.47465 0.764672 4.42373 0.816401 4.42373 0.878101V1.46866ZM7.95154 2.23347L1.66477 2.23333V10.9723C1.66477 11.6662 2.22343 12.2353 2.90448 12.2353H9.09552C9.77658 12.2353 10.3352 11.6662 10.3352 10.9723V2.23333L7.95154 2.23347Z" fill="#CB4B17"/>
                    </svg>
                  </button>
                </div>`;
      }).join('');

      const money = CFG?.bundle?.formatted_price || '0.00';
      sticky.innerHTML = `
        <div class="bb-sticky__wrap">
          <div class="bb-progress">${slotsHtml}</div>
          <div class="bb-sticky__price">
            <span class="bb-price-label">${isAR ? 'سعر الحزمة' : 'Bundle Price'}</span>
            <span class="bb-price-value">${money}</span>
          </div>
          <button type="button" class="bbh__checkout-link" data-bundle-checkout disabled>
            ${isAR ? 'الدفع' : 'Check Out'}
          </button>
        </div>`;
      sticky.style.setProperty('--bb-steps', CFG.slots.length);
      sticky.querySelector('[data-bundle-checkout]').addEventListener('click', handleCheckout);
    }

    function syncSticky() {
      const nextSlot = getFirstUnfilledSlot();
      $$('.bb-step', sticky).forEach((step, index) => {
        const key = step.dataset.slotKey;
        const isFilled = (STATE.slots[key]?.length || 0) > 0;

        step.classList.toggle('is-filled', isFilled);
        step.classList.toggle('is-next', nextSlot && key === nextSlot.key);

        // Show/hide remove button based on filled state
        const removeBtn = step.querySelector('.bb-remove');
        if (removeBtn) {
          if (isFilled) {
            removeBtn.removeAttribute('hidden');
            removeBtn.style.display = 'inline-flex';
          } else {
            removeBtn.setAttribute('hidden', '');
            removeBtn.style.display = 'none';
          }
        }
      });

      // Checkout button enables only when the wizard has reached 'done'.
      // (Old behavior: enabled as soon as all required slots filled.)
      // This preserves the new optional Add-ons + Message phases in between.
      const checkoutBtns = $$('[data-bundle-checkout]');
      const ready = STATE.phase === 'done';
      checkoutBtns.forEach(btn => {
        btn.disabled = !ready;
        btn.setAttribute('aria-disabled', String(!ready));
      });
    }

    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting);
    }, { rootMargin: '-20px 0px 0px 0px', threshold: 0 });
    observer.observe(header);

    async function handleCheckout() {
      const checkoutButtons = $$('[data-bundle-checkout]');
      if (checkoutButtons[0]?.disabled) return;

      const slotItems = Object.values(STATE.slots).flat();
      const addonItems = Object.values(STATE.addons).flat();

      if (slotItems.length === 0) return;

      checkoutButtons.forEach(btn => {
        btn.textContent = isAR ? 'جاري المعالجة…' : 'Processing…';
        btn.disabled = true;
      });

      const resetButtons = () => {
        checkoutButtons.forEach(btn => {
          btn.textContent = isAR ? 'الدفع' : 'Check Out';
          btn.disabled = false;
        });
      };

      try {
        const variantId = Number(CFG?.bundle?.variant_id);
        if (!variantId) throw new Error('Missing bundle variant ID');

        // ====================================================
        // BUKHOOR 1 CARVE-OUT — unchanged legacy flow.
        // Keeps _component_references + _custom_price + Expand
        // operation so the buy-1-get-1-free promo continues to
        // work. Cart shape: single parent line that gets expanded
        // into N child lines by the cart Function.
        // ====================================================
        if (isBukhoor1) {
          const allItems = [...slotItems, ...addonItems];
          const componentRefs = allItems.map(item => `gid://shopify/ProductVariant/${item.variantId}`);
          const properties = {
            '_component_references': JSON.stringify(componentRefs),
            '_bundle_configuration': CFG.bundle.title,
          };

          const slot1Item = slotItems[0];
          if (slot1Item && slot1Item.price) {
            // KD subunits = price * 1000 (3 decimals).
            const priceInCents = Math.round(parseFloat(slot1Item.price) * 1000);
            properties['_custom_price'] = String(priceInCents);
          }

          slotItems.forEach((item, index) => {
            const isSlot2 = index === 1;
            properties[`Component ${index + 1}`] = isSlot2 ? `${item.title} (Free)` : item.title;
          });

          addonItems.forEach((item) => {
            const cat = ADDONS.find(c => c.key === item.categoryKey);
            const label = cat ? (isAR ? cat.label_ar : cat.label_en) : 'Add-on';
            properties[label] = item.title;
          });

          if (MESSAGE_ENABLED) {
            const m = STATE.message || {};
            if (m.from) properties['From'] = m.from;
            if (m.to) properties['To'] = m.to;
            if (m.message) properties['Message'] = m.message;
          }

          const items = [{ id: variantId, quantity: 1, properties: properties }];
          const res = await fetch(window.BB_ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) throw new Error('Failed to add bundle to cart');
          sessionStorage.removeItem(SS_KEY);
          window.location.href = window.BB_ROOT + 'cart';
          return;
        }
        // ====================================================
        // END BUKHOOR 1 CARVE-OUT.
        // ====================================================

        // FIXED-PARENT FLOW WITH EXPANSION (every non-bukhoor bundle).
        // Bundle parent line carries `_component_references` (variant
        // GIDs of slot picks) and `_custom_price` (parentMajor × 1000)
        // so the cart Function expands the parent into one child line
        // per slot pick AND distributes the parent price evenly across
        // the children (FixedPricePerUnit). Customer pays the parent
        // variant's price; fulfillment sees the component SKUs as
        // individual line items.
        //
        // Add-ons are NOT in `_component_references` — they ride as
        // their own `items[]` entries below at their natural variant
        // prices, so the Function leaves them alone.
        const componentRefs = slotItems.map(
          (item) => `gid://shopify/ProductVariant/${item.variantId}`
        );
        const parentMajor = parseLocalePrice(
          CFG.bundle.formatted_price || CFG.bundle.price || '0'
        );
        const customPriceScaled = Math.round(parentMajor * 1000);

        const properties = {
          '_component_references': JSON.stringify(componentRefs),
          '_custom_price': String(customPriceScaled),
          '_bundle_configuration': CFG.bundle.title,
          '_bundle_components': JSON.stringify(
            slotItems.map((item) => ({
              variantId: item.variantId,
              title: item.title,
              handle: item.handle,
            }))
          ),
        };
        slotItems.forEach((item, index) => {
          properties[`Component ${index + 1}`] = item.title;
        });
        if (MESSAGE_ENABLED) {
          const m = STATE.message || {};
          if (m.from || m.to || m.message) {
            if (m.from) properties['From'] = m.from;
            if (m.to) properties['To'] = m.to;
            if (m.message) properties['Message'] = m.message;
          }
        }

        const items = [{ id: variantId, quantity: 1, properties: properties }];
        addonItems.forEach((addon) => {
          const cat = ADDONS.find((c) => c.key === addon.categoryKey);
          const addonProps = { '_bundle_addon_for': CFG.bundle.title };
          if (cat) {
            addonProps[isAR ? 'إضافة' : 'Add-on'] = (isAR ? cat.label_ar : cat.label_en);
          }
          items.push({
            id: Number(addon.variantId),
            quantity: 1,
            properties: addonProps,
          });
        });

        const res = await fetch(window.BB_ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) throw new Error('Failed to add bundle to cart');
        sessionStorage.removeItem(SS_KEY);
        window.location.href = window.BB_ROOT + 'cart';
      } catch (err) {
        console.error('[Bundle] Error:', err);
        alert(isAR ? 'تعذر إتمام الطلب. يرجى المحاولة مرة أخرى.' : 'Could not complete checkout. Please try again.');
        resetButtons();
      }
    }

    $$('[data-bundle-checkout]', header).forEach(btn => btn.addEventListener('click', handleCheckout));

    // --- FORCE IMAGE LOADING ON PAGE ---
    function forceLoadAllImages() {
      $$('.grid-product').forEach(card => {
        const images = $$('img', card);
        images.forEach(img => {
          if (img.loading === 'lazy') {
            img.loading = 'eager';
          }
          if (img.dataset.src && !img.src) {
            img.src = img.dataset.src;
          }
          if (img.dataset.srcset && !img.srcset) {
            img.srcset = img.dataset.srcset;
          }
        });
      });
    }

    // --- INITIALIZATION ---
    buildStickyUI();

    // DON'T pre-fill slot 2 for Bukhoor 1 - it will be auto-filled when slot 1 is added

    renderSlots();
    renderStepFilters();

    forceLoadAllImages();

    // Reconcile saved phase against current CFG (e.g. user advanced past
    // slots before reload, or addons were removed since last visit).
    recomputePhase();
    saveState();

    setTimeout(() => {
      // renderPhaseUI dispatches to slot/addon/message rendering as needed.
      renderPhaseUI();
      syncSticky();
      console.log(
        `[Bundle] Initialized — slots=${CFG.slots.length} addons=${ADDONS.length} ` +
        `message=${MESSAGE_ENABLED} phase=${STATE.phase}`
      );
      if (isBukhoor1) {
        console.log('[Bukhoor 1] ✅ Special mode active');
      }
    }, 300);
  });
})();


/* ============================================================
   "+" slot jumps to the product picker
   Added: clicking a bundle slot activates its tab and scrolls down.
   ============================================================ */
(function () {
  'use strict';

  if (window.__bbSlotJumpBound) return;
  window.__bbSlotJumpBound = true;

  var SLOTS_SEL  = '[data-slot]';
  var TABS_SEL   = '#bundle-step-filters .category-link';
  var SCROLL_SEL = '#bundle-step-filters';
  var STICKY_SEL = '.bb-sticky';

  var GAP = 16;
  var RENDER_WAIT = 80;

  function topOffset() {
    var sticky = document.querySelector(STICKY_SEL);
    return (sticky ? sticky.offsetHeight : 0) + GAP;
  }

  function tabForSlot(slot) {
    var key  = slot.getAttribute('data-slot-key') || '';
    var tabs = [].slice.call(document.querySelectorAll(TABS_SEL));

    var hit = tabs.filter(function (tab) {
      var tag = tab.getAttribute('data-filter-tag') || '';
      return tag === key || tag.slice(-(key.length + 1)) === '-' + key;
    })[0];
    if (hit) return hit;

    var slots = [].slice.call(document.querySelectorAll(SLOTS_SEL));
    return tabs[slots.indexOf(slot)] || null;
  }

  function scrollToPicker() {
    var target = document.querySelector(SCROLL_SEL) ||
                 document.querySelector('[data-scroll-to]');
    if (!target) return;

    var y = target.getBoundingClientRect().top + window.pageYOffset - topOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.bb-remove, [data-action], a, button')) return;

    var slot = e.target.closest(SLOTS_SEL);
    if (!slot) return;

    var tab = tabForSlot(slot);
    if (tab && !tab.classList.contains('active')) tab.click();

    setTimeout(scrollToPicker, RENDER_WAIT);
  }, false);

  var style = document.createElement('style');
  style.textContent =
    '.bb-slot{cursor:pointer}' +
    '.bb-slot:hover .bb-slot__placeholder{opacity:.7;transition:opacity .15s ease}';
  document.head.appendChild(style);
})();